import type { FaireProductEntity } from "../../entity_types/product";

export const p_k5hhczmne5: FaireProductEntity = {
  token: "p_k5hhczmne5",
  type: "product",
  name: "Solid Color Canvas Tote Bag Shoulder Bag with Large Capacity",
  brandToken: "b_3fb7o7n9vq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ba0872ba85bd1916cc9e09b2a7a639b69ab75aa65e4ac6ea41cbe8122472a978.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/129be6d3054aa738c10c7464dd23e141f40e9a42875b0aaa1af7f5c60c9ea04c.png",
    "https://cdn.faire.com/fastly/ed3a52e4c936426ecc084cf40cef1e90c3c604a4e4ec373226a8df773bbd820f.png",
    "https://cdn.faire.com/fastly/92112e56840e836d8a49f83f982a82c1f13fac24398f2befe14897efee1d4bfe.png",
    "https://cdn.faire.com/fastly/7a2fb8b58283e96e6f3dbb0c1456ea45e6dc699282bfac9c4241078c49f71c8f.png",
    "https://cdn.faire.com/fastly/f4e7a3ac034b665730362bcd975249c375a7d1cdbed052114241142496b1183a.png",
    "https://cdn.faire.com/fastly/dff5128f2dc0119b7fe17b2f5b2a8d8410fa111df2b56e32dbf566ce8f19e7aa.png",
    "https://cdn.faire.com/fastly/4620286d7443d4cb6ae1e1459e3291ea818b84d5617eb05f2d5eab56f4a3265e.jpeg",
    "https://cdn.faire.com/fastly/eb1f228a869c72166421af1f059200054daa6f7df459372c2f593703bf21c0be.jpeg",
    "https://cdn.faire.com/fastly/1bb1a6a2a169f1b531133e91d3ff1358cc0f8e4560bd360b675ab30c83c0d13d.jpeg",
    "https://cdn.faire.com/fastly/8e274dd9693ef83c018b754cc97ae37ba37d7820dffa1d3e844d3c5b9c9d3f95.jpeg",
    "https://cdn.faire.com/fastly/111c0805c15a0311ef93dfbb5ef71ceae0338bbd33f7eef9baef0463b6bcf641.jpeg",
    "https://cdn.faire.com/fastly/e01e5e5947ec437087da3ec3b24b83955bb2d75225962720a113c3b67ce79080.jpeg",
    "https://cdn.faire.com/fastly/3977f8b50ddf7d9eaeaab3cd4e41ca36cb0f7c02d9fedb86d2be422a4feda0b6.jpeg",
    "https://cdn.faire.com/fastly/9973d830ca326940c72c1e853abc194d44fdfff8f0cdf4ce7ab6fb4fdbabd3e0.jpeg",
    "https://cdn.faire.com/fastly/c02f899a5c42d426cb75a51720ccfe3949773bee7028cb2d534832f5a11974b8.jpeg",
    "https://cdn.faire.com/fastly/8fdbe21c3140d349808e9f2a74a6a6ff2a6786b9f9488939ace29b56b468246f.jpeg",
    "https://cdn.faire.com/fastly/48ea983c40cd92f8a25be20f252e6751e907a6654a280d0acb31754fc4e02a10.jpeg",
    "https://cdn.faire.com/fastly/d1bf8104b58280682fc9d9579899cc0f32a549248bd19788fd0a2fecf4bc17dd.jpeg",
    "https://cdn.faire.com/fastly/c9e608360629751b0f118f3421291cc57b189d2bc778b38c303b9acc73a163ad.jpeg",
    "https://cdn.faire.com/fastly/090a71312a263cc394a3665336535fa6280495ec26b6590680e4c1a03e6bcca9.jpeg",
    "https://cdn.faire.com/fastly/d74a23c243c5f7a398fea1b13201f687f1a95ede686db3f35afd5fa6e237ae60.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "Dimensions: 43*13*29 cm/ 16.9*5.1*11.4 inch\n\nFashion \nSolid Color \nLarge Capacity \nPortable \nCanvas Not Easy to Get Wet\nHand carry, shoulder carry",
  tags: [],
  msrpDollars: 24.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:57.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
